if (!customElements.get('countdown-timer-bar')) {
  class CountdownBar extends HTMLElement {
constructor() {
  super();

  const durationMinutes =
    parseInt(this.getAttribute('data-duration'), 10) || 40;

  this.DURATION = durationMinutes * 60 * 1000;

  // Include duration in key
  this.STORAGE_KEY = `countdown_timer_expiry_${durationMinutes}`;

  this.initTimer();

  this.interval = setInterval(() => {
    this.updateTimer();
  }, 1000);

  this.calcHeight();
}

initTimer() {
  const now = Date.now();

  let expiry = localStorage.getItem(this.STORAGE_KEY);
  let savedDuration = localStorage.getItem(
    `${this.STORAGE_KEY}_duration`
  );

  if (
    !expiry ||
    parseInt(savedDuration, 10) !== this.DURATION ||
    now >= parseInt(expiry, 10)
  ) {
    expiry = now + this.DURATION;

    localStorage.setItem(this.STORAGE_KEY, expiry);
    localStorage.setItem(
      `${this.STORAGE_KEY}_duration`,
      this.DURATION
    );
  }

  this.expiryTime = parseInt(expiry, 10);

  this.daysEl = this.querySelector('.countdown-timer-bar__days');
  this.hoursEl = this.querySelector('.countdown-timer-bar__hours');
  this.minutesEl = this.querySelector('.countdown-timer-bar__minutes');
  this.secondsEl = this.querySelector('.countdown-timer-bar__seconds');

  this.updateTimer();
}

    updateTimer() {
      const now = Date.now();
      let distance = this.expiryTime - now;

      // Reset timer when finished
      if (distance <= 0) {
        this.expiryTime = now + this.DURATION;
        localStorage.setItem(this.STORAGE_KEY, this.expiryTime);
        distance = this.DURATION;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );
      const seconds = Math.floor(
        (distance % (1000 * 60)) /
        1000
      );

      if (this.daysEl) {
        this.daysEl.textContent = String(days).padStart(2, '0');
      }

      if (this.hoursEl) {
        this.hoursEl.textContent = String(hours).padStart(2, '0');
      }

      if (this.minutesEl) {
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
      }

      if (this.secondsEl) {
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    calcHeight() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.documentElement.style.setProperty(
              "--countdown-bar-height",
              `${entry.boundingClientRect.height}px`
            );
          } else {
            document.documentElement.style.setProperty(
              "--countdown-bar-height",
              "0px"
            );
          }
        });
      });

      observer.observe(this);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('countdown-timer-bar', CountdownBar);
}